import { api, ApiRes } from './client'
import { Wallet, WalletTransaction } from '../account/useWallet'
import { BankAccountStatus } from '../../typings'

export interface BankAccount {
    id?: string
    iban?: string
    bic?: string
    holder?: string
    is_main?: boolean
    status?: BankAccountStatus
}

export interface MoneyWithdrawal {
    id: string
    status: 'pending' | 'done' | 'canceled'
    amount: number
    created_at: string | Date
}

export interface PaymentRequest {
    order_id?: string
    wallet_id?: string
    amount: number
    payment_method: 'credit_card'
    lang: string
    return_url: string
    cancel_url: string
    error_url: string
}
export interface WalletPaymentRequest extends PaymentRequest {
    wallet_id: string
}
export interface OrderPaymentRequest extends PaymentRequest {
    order_id: string
}

export interface PaymentResponse {
    redirectUrl: string
}

export interface ApiWalletResponse {
    success: boolean
    wallets: Wallet[]
    transactions: Array<WalletTransaction>
    bankAccounts?: Array<BankAccount>
    moneyWithdrawals?: Array<MoneyWithdrawal>
}

interface MoneyWithdrawalRequest {
    amount: number
    bank_account_id: string
}

export const getNaturalWallet = (): ApiRes<ApiWalletResponse> | null => {
    try {
        return api.get('wallet')
    } catch (error) {
        return null
    }
}

export const getLegalWallet = (legalProfileId: string): ApiRes<ApiWalletResponse> =>
    api.get(`wallet/legal/${legalProfileId}`)

export const postWalletMoneyWithdrawal = (payload: MoneyWithdrawalRequest): ApiRes<ApiWalletResponse> =>
    api.post('money-withdrawals', payload)

export const putCancelWalletMoneyWithdrawal = (moneyWithdrawalId: string): ApiRes<ApiWalletResponse> =>
    api.put(`money-withdrawals/${moneyWithdrawalId}/cancel`)

export const postPayment = (payment: PaymentRequest): ApiRes<PaymentResponse> => api.post('payments', payment)
